import { useAuth } from '../context/AuthContext'
import { Navigate } from 'react-router-dom'

/**
 * Root index route: redirects based on authentication state.
 * - Not authenticated (or still loading) → /login
 * - Authenticated → /dashboard
 */
export default function RootRedirect() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--color-surface-subtle)]">
        <div className="animate-spin rounded-full h-10 w-10 border-4 border-[var(--color-brand-200)] border-t-[var(--color-brand-500)]" />
      </div>
    )
  }

  return <Navigate to={user ? '/dashboard' : '/login'} replace />
}
